import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { SimplebarAngularModule } from 'simplebar-angular';
import { DetailCommissionEventListModule } from '../dave-commission-module/components/detail-commission/detail-commission-event-list/detail-commission-event-list.module';
import { DaveDoubleIconModule } from '../dave-double-icon/dave-double-icon.module';
import { DaveEventListEntryModule } from "../dave-event-list-entry/dave-event-list-entry.module";
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { SelectSearchModule } from '../dave-utils-module/select-search/select-search.module';
import { EditCustomerspecificationtypeComponent } from '../detail-list-template-dialog/edit-customerspecificationtype/edit-customerspecificationtype.component';
import { EditPersontypeComponent } from '../detail-list-template-dialog/edit-personType/edit-persontype.component';
import { DaveListCardModule } from './../dave-list-card/dave-list-card.module';
import { DetailPersonComponent } from './components/detail-person/detail-person.component';
import { PersonDetailFormComponent } from './components/person-detail-form/person-detail-form.component';
import { PersonModalComponent } from './components/person-modal/person-modal';
import { SelectPersonsComponent } from './components/select-persons/select-persons.component';
import { DavePersonRoutingModule } from './dave-person-routing.module';
import { GoToButtonsModule } from '../go-to-buttons/go-to-buttons.module';
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { DetailPersonPopupComponent } from './components/detail-person-popup/detail-person-popup.component';

@NgModule({
    declarations: [DetailPersonComponent, PersonDetailFormComponent, PersonModalComponent, SelectPersonsComponent, DetailPersonPopupComponent],
    imports: [
        DavePersonRoutingModule,
        CommonModule,
        DaveSharedComponentsModule,
        FontAwesomeModule,
        MatTooltipModule,
        AppButtonModule,
        DaveLoadingModule,
        SimplebarAngularModule,
        MatCheckboxModule,
        MatTableModule,
        MatDialogModule,
        MatChipsModule,
        DaveListCardModule,
        MatSortModule,
        ScrollingModule,
        TableVirtualScrollModule,
        MatCardModule,
        DaveEventListEntryModule,
        MatMenuModule,
        DetailCommissionEventListModule,
        DaveDoubleIconModule,
        RouterLink,
        MatFormFieldModule,
        SelectSearchModule,
        ReactiveFormsModule,
        EditCustomerspecificationtypeComponent,
        EditPersontypeComponent,
        GoToButtonsModule,
        MatButtonModule,
    ],
})
export class DavePersonModule {}
